module.exports = __webpack_public_path__ + "img/sand-decal-16.d32c84ba.png";